import React, { useEffect, useState } from 'react';
import AppTitle from '../../../layouts/AppTitle';
import { productBg2 } from '../../../../assets/images';
import { Alert, Box, Grid, IconButton, Tooltip } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import LogoutIcon from '@mui/icons-material/Logout';
import { getPageContent, userLogout } from '../../../../store/actions/AuthActions';
import { Link, useNavigate } from 'react-router-dom';
import AppLoader from '../../../pages/AppLoader';
import AppDatagridTable from '../../../layouts/AppDatagridTable';
import { userOrdersTable } from '../../../../utils/tableElements';
import moment from 'moment';

const MyAccount = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const accountDetails = [
    { icon: 'lastudioicon-single-01-2', field: 'name', title: 'Name' },
    { icon: 'lastudioicon-mail', field: 'email', title: 'Email' },
    { icon: 'lastudioicon-b-whatsapp', field: 'phone', title: 'Mobile Number' },
  ];

  const user = useSelector(state => state?.auth?.user);
  const token = useSelector(state => state?.auth?.token);
  const orders = useSelector(state => state?.auth?.orders);

  const [tableData, setTableData] = useState({});

  useEffect(() => {
    dispatch(getPageContent('getUserOrders', token));
  }, []);

  useEffect(() => {
    if (tableData) {
      const rows = orders?.map(o => ({
        ...o,
        orderedOn: moment(o?.orderedOn).format('DD/MM/YYYY hh:mm A'),
        expectedDeliveryDate: moment(o?.expectedDeliveryDate).format('DD/MM/YYYY'),
        price: o?.product?.price,
        title: o?.product?.title,
      }));
      setTableData({ rows, columns: userOrdersTable });
    }
  }, [orders]);

  const handleLogout = () => {
    dispatch(userLogout(navigate));
  };

  return orders ? (
    <div>
      <AppTitle from={'Home'} to='My Account' bgImg={productBg2} title={'My Account'} />

      <div className='container my-10'>
        <div className='row'>
          <div className='col-12 col-md-4 mb-4 mb-md-0'>
            <div className='checkout-box m-0 m-md-1'>
              <div className='d-flex justify-content-between align-items-center h-100'>
                <h4 className='mb-4'>Account Details</h4>
                <Tooltip title='Logout'>
                  <IconButton onClick={handleLogout} sx={{ my: 'auto' }}>
                    <LogoutIcon fontSize='small' />
                  </IconButton>
                </Tooltip>
              </div>

              {accountDetails?.map(d => (
                <p style={{ fontSize: '14px' }}>
                  <strong style={{ minWidth: 20, display: 'inline-block' }} className='social-item'>
                    <i className={`${d?.icon}`} style={{ fontWeight: 600 }} />
                  </strong>
                  <span> {user?.[d?.field]}</span>
                </p>
              ))}

              {/* <button
                className='btn btn-hover-primary btn-block btn-outline-black rounded-0 mt-4'
                onClick={handleLogout}
              >
                <LogoutIcon /> Log out
              </button> */}
            </div>
          </div>

          <div className='col-12 col-md-8'>
            <div className='checkout-box m-0 m-md-1'>
              <h4 className='mb-4'>My Orders</h4>

              <div>
                {orders?.length === 0 ? (
                  <Alert severity='warning'>
                    No orders placed.{' '}
                    <Link style={{ textDecoration: 'underline', fontWeight: 600 }} to='/shop'>
                      Tap here
                    </Link>{' '}
                    to explore our collection and shop now!
                  </Alert>
                ) : (
                  <div>
                    <AppDatagridTable
                      tableData={tableData}
                      checkboxSelection={false}
                      height='50vh'
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    <AppLoader />
  );
};

export default MyAccount;
